module.exports = __webpack_public_path__ + "img/scanner.6abd8628.png";